export const requestStarted = () => ({
  type: 'REQUEST_STARTED',
});

export const requestCompleted = () => ({
  type: 'REQUEST_COMPLETED',
});
